import getApi, {createWrapper, getCommonBaseUrl} from '@web/helpers/api'

import {GFPWaterfallParams, GFPWaterfallResponse} from '../interfaces'

const api = getApi(getCommonBaseUrl())

const getGFPWaterfallResponse = (params: GFPWaterfallParams) => {
    return createWrapper<GFPWaterfallResponse>(
        api.get('/gfpWaterfallResponse', {
            params,
        }),
    )
}

export default {
    getGFPWaterfallResponse,
}
